import {BaseService} from "./base.service";

class PackagesService extends BaseService {

    constructor() {
        super('api/packages')
    }

}

export const packagesService = new PackagesService();
